import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5204ca0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import { computed } from 'vue'
/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
  icon: String,
  size: {
    type: Number,
    default: 32,
  },
  width: {
    type: Number,
    default: undefined,
  },
  height: {
    type: Number,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

const spritePath = require('@/assets/icons/sprite.svg')



const style = computed(() => {
  const finalHeight = (props.height || props.size) + 'px'
  const finalWidth = (props.width || props.size) + 'px'
  return {
    width: finalWidth,
    minWidth: finalWidth,
    height: finalHeight,
    minHeight: finalHeight,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon",
    style: _normalizeStyle(_unref(style))
  }, [
    _createElementVNode("use", {
      href: `${_unref(spritePath)}#icon-${__props.icon}`
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})